import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import useCcWebviewUtilsHelper from '@di-shared/features/common/useCcWebviewUtilsHelper';

export interface HeaderCloseButtonProps {
  onClick?(): void;
}

function HeaderCloseButton({onClick}: HeaderCloseButtonProps) {
  const {t} = useInferableTranslation();
  const {backOrClose} = useCcWebviewUtilsHelper();

  return (
    <button
      aria-label={t('ctn_home_close')}
      className="btn btn_ic"
      type="button"
      onClick={onClick || (() => backOrClose())}
    >
      <span
        className="ic ic_close_24px"
        aria-hidden="true"
      />
    </button>
  );
}

export default HeaderCloseButton;
